/** Représentation statique des taches — prise en charge nouveau client / projets client */

export type ProcedureTaskStatus = 'done' | 'pending';

export interface ProcedureClientTask {
  id: string;
  /** Texte brut ; utiliser ***mot*** pour mettre en évidence (ex. note ERP) */
  label: string;
  status: ProcedureTaskStatus;
  /** Texte d’aide affiché via l’icône information sur la ligne */
  info?: string;
}

export interface ProcedureClientSection {
  id: string;
  title: string;
  tasks: ProcedureClientTask[];
}

export const procedureGestionProjetsClientSections: ProcedureClientSection[] = [
  {
    id: 'mise-en-marche',
    title: 'Mise en marche du projet',
    tasks: [
      { id: 'm1', label: "Envoi du courriel de planification au client", status: 'done' },
      {
        id: 'm2',
        label: "Vérification de l'Offre de service avec le directeur de comptes",
        status: 'done',
        info:
          "Cette vérification a pour but de bien comprendre les besoins du client et ce qui a été discuté lors de la signature de l'ODS.",
      },
      { id: 'm3', label: 'Avertir la facturation du début du mandat', status: 'done' },
      {
        id: 'm4',
        label:
          "Ajouter une note dans l'entête du client dans le ERP ***Projet en cours***",
        status: 'done',
      },
      { id: 'm5', label: "Communiquer avec l'ancien fournisseur du client", status: 'done' },
      { id: 'm6', label: "Faire l'inventaire du parc informatique du client", status: 'done' },
      {
        id: 'm7',
        label: 'Envoyer la liste des postes informatiques à modifier ou changer',
        status: 'pending',
      },
      { id: 'm8', label: "Ajouter l'information du client dans le ERP", status: 'pending' },
    ],
  },
  {
    id: 'm365',
    title: 'Environnement Microsoft 365',
    tasks: [
      { id: 'o1', label: 'Création du Tenant', status: 'done' },
      { id: 'o2', label: 'Configurer le Tenant de Microsoft', status: 'done' },
      { id: 'o3', label: 'Configuration des sauvegardes Microsoft 365 BZ', status: 'done' },
      { id: 'o4', label: 'Création des équipes Teams', status: 'done' },
      { id: 'o5', label: 'Commander les licences selon le contrat', status: 'pending' },
      { id: 'o6', label: 'Configurer Microsoft Intune', status: 'pending' },
      { id: 'o7', label: 'Transfert des données', status: 'pending' },
    ],
  },
  {
    id: 'deploiement-cloud',
    title: 'Déploiement des solutions Cloud',
    tasks: [
      { id: 'd1', label: 'Tournée de postes', status: 'done' },
      { id: 'd2', label: 'Suivi après déploiement', status: 'pending' },
      { id: 'd3', label: "Activer l'accès conditionnel 2FA", status: 'done' },
      { id: 'd4', label: 'Activer la GéoIp', status: 'done' },
    ],
  },
  {
    id: 'cloture',
    title: 'Clôture du projet',
    tasks: [
      { id: 'c1', label: 'Gestion du projet', status: 'done' },
      { id: 'c2', label: 'Mise à jour de la documentation', status: 'done' },
      {
        id: 'c3',
        label:
          "Enlever la note dans l'entête du client dans le ERP ***Projet en cours***",
        status: 'done',
      },
      { id: 'c4', label: 'Modification des Guides dans Servo', status: 'done' },
      {
        id: 'c5',
        label: 'Envoyer un courriel aux Techniciens de BZ et DDC',
        status: 'done',
        info:
          'Le courriel envoyé vise à informer les techniciens que le projet est maintenant complété et que les demandes peuvent désormais être acheminées par le SAC. En ajoutant le DDC au courriel, ce dernier est informé simultanément de la fin du projet.',
      },
      { id: 'c6', label: 'Vérification de mandat.', status: 'done' },
    ],
  },
];
